import React, { useContext } from 'react';

import Footer from 'components/footer';
import Header from 'components/header';
import MetaTags from 'components/meta-tags';

import LocaleContext from 'contexts/locale-context';

import './index.css';


const PrivacyPolicy = () => {
  const { translations } = useContext(LocaleContext);
  const pageTranslations = translations['privacy-policy'];

  return (
    <div className='container'>
      <MetaTags title={pageTranslations.title} />

      <Header />
      <div className='privacyPolicy__body'>
        <h1 className="center-text">{pageTranslations.title}</h1>
        <section>
          <p>{pageTranslations.s1p1}</p>
        </section>
        <section>
          <p>{pageTranslations.s2p1}</p>
          <p>{pageTranslations.s2p2}</p>
        </section>
        <section>
          <h4>{pageTranslations.s3h}:</h4>
          <ul>
            <li>
              <p>{pageTranslations.s3p1}.</p>
            </li>
            <li>
              <p>{pageTranslations.s3p2}.</p>
            </li>
            <li>
              <p>{pageTranslations.s3p3}.</p>
            </li>
            <li>
              <p>{pageTranslations.s3p4}.</p>
            </li>
            <li>
              <p>{pageTranslations.s3p5}.</p>
            </li>
            <li>
              <p>{pageTranslations.s3p6}.</p>
            </li>
            <li>
              <p>{pageTranslations.s3p7}.</p>
            </li>
            <li>
              <p>{pageTranslations.s3p8}.</p>
            </li>
            <li>
              <p>{pageTranslations.s3p9}.</p>
            </li>
          </ul>
        </section>
        <h2>GDPR</h2>
        <section>
          <p>{pageTranslations.s4p1}.</p>
        </section>
        <section>
          <h4>{pageTranslations.s5p1}</h4>
          <ul>
            <li>{pageTranslations.s5l1}.</li>
            <li>{pageTranslations.s5l2}.</li>
          </ul>
        </section>
        <section>
          <h4>{pageTranslations.s6h} </h4>
          <ul>
            <li>{pageTranslations.s6l1}</li>
            <li>{pageTranslations.s6l2}</li>
            <li>{pageTranslations.s6l3}</li>
          </ul>
        </section>
      </div>
      <Footer suffix='privacy-policy'/>
    </div>
  );
}

export default PrivacyPolicy;